// The mode and QA recipients are saved in one application-database transaction.
export async function saveIntegrationSettings(api, input) {
  const fail = code => Object.assign(new Error(code), { code });
  if (!['SAFE_TEST', 'LIVE'].includes(input.mode) || !Number.isInteger(input.modeRevision)) throw fail('MODE_REVISION_REQUIRED');
  if (input.mode === 'LIVE' && input.confirmLive !== true) throw fail('LIVE_CONFIRMATION_REQUIRED');
  const recipients = [...new Set((input.recipients || []).map(v => v.trim().toLowerCase()).filter(Boolean))];
  if (input.mode === 'SAFE_TEST' && (!recipients.length || recipients.length > 10 || recipients.some(v => !/^[^\s@,;]+@[^\s@,;]+\.[^\s@,;]+$/.test(v)))) throw fail('QA_RECIPIENTS_INVALID');
  const response = await api.post('/admin/integration-settings/mode', {
    integration_mode: input.mode, expected_revision: input.modeRevision,
    qa_recipients: recipients, confirm_live: input.mode === 'LIVE'
  });
  return { settings: response.data.data };
}
